export const selectTopicListState = ({ topicList }) => topicList;
